/** *
 *  A type representing the current state while solving the puzzle.
 */
enum AnswerState {
  INITIAL,
  READY_TO_COMPUTE,
  COMPUTING,
  COMPUTING_DONE,
  VERIFIED_CORRECT,
  VERIFIED_INCORRECT
}

export default AnswerState;
